import React from 'react'


// redux 
import { useSelector, shallowEqual } from "react-redux";
import { RootState } from "../../setup/redux/RootReducer";

export const useAppPermission = () => {
  
    const userData: any = useSelector<RootState>(
        ({ auth }) => auth?.user,
        shallowEqual
      );
 
    const permission = Array.isArray(userData?.permissions) ?  userData.permissions : []
    return [permission];
}
